module.exports = __webpack_public_path__ + "8901c622f00447700a8008f612754978.svg";